module.exports = __webpack_public_path__ + "img/Forgot password.fe0facde.svg";